import "./VoteForm.scss";
import Card from "../../card/Card";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Compressor from "compressorjs";
import axios from "axios";
import { BsTrash } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import {
  getTypes,
  getCategories,
} from "../../../redux/features/categoryAndType/categoryAndTypeSlice";

const VoteForm = ({ saveVote, vote, setVote, isEditing }) => {
  const dispatch = useDispatch();

  // const [filteredTypes, setFilteredTypes] = useState([]);
  // const { categories, types } = useSelector((state) => state.category);

  // useEffect(() => {
  //   dispatch(getCategories());
  //   dispatch(getTypes());
  // }, [dispatch]);

  //   Filter brands based on selectedCategory
  // const filterTypes = (selectedCategory) => {
  //   const newTypes = types.filter((type) => type.category === selectedCategory);
  //   setFilteredTypes(newTypes);
  // };

  // useEffect(() => {
  //   filterTypes(post?.category);
  // }, [post?.category]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setVote({ ...vote, [name]: value });
  };

  // const removeImage = (image) => {
  //   setFiles(files.filter((img) => img !== image));
  // };

  return (
    <div className="add-product">
      <Card cardClass={"card"}>
        <br />
        <form onSubmit={saveVote}>
          <label>Title:</label>
          <input
            type="text"
            placeholder="Post title"
            name="title"
            value={vote?.title}
            onChange={handleInputChange}
            required
          />

          <label>Option One:</label>
          <input
            type="text"
            placeholder="Post Option One"
            name="optionOne"
            value={vote?.optionOne}
            onChange={handleInputChange}
            required
          />

          <label>Option Two:</label>
          <input
            type="text"
            placeholder="Post Option Two"
            name="optionTwo"
            value={vote?.optionTwo}
            onChange={handleInputChange}
            required
          />

          <label>Option Three:</label>
          <input
            type="text"
            placeholder="Post Option Three"
            name="optionThree"
            value={vote?.optionThree}
            onChange={handleInputChange}
            required
          />

          <div className="--my">
            <button type="submit" className="--btn --btn-primary">
              Save Vote
            </button>
          </div>
        </form>
      </Card>
    </div>
  );
};
export default VoteForm;
